import { createSelector } from 'reselect';
import { IStore } from 'store/interface';

export const getDialogState = ({ dialog }: IStore, dialogName: string) => dialog.get(dialogName);

export const getActiveDialogs = createSelector(
  ({ dialog }: IStore) => dialog,
  dialog => Array.from(dialog.keys())
);
